export default "__VITE_ASSET__5f7lVvTV__"